import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {AuthService} from '../service/auth.service';
import {Constant} from "../shared/model/Constant";
import {LoadingController, ToastController} from "@ionic/angular";

@Component({
  selector: 'app-two-fa',
  templateUrl: './two-fa.component.html',
  styleUrls: ['./two-fa.component.scss'],
})
export class TwoFaComponent implements OnInit {
  @Input() tfa: any;
  @Output() valueChange = new EventEmitter();
  otp: number;
  errorMessage: any;

  data: any = [];
  optInput: number[] = [];
  userId: any;
  loading: HTMLIonLoadingElement;

  constructor(private authService: AuthService, public loadingController: LoadingController, public toastController: ToastController,) {
  }

  async ngOnInit() {
    this.userId = localStorage.getItem(Constant.userId);
    this.loading = await this.loadingController.create({
      message: '',
      spinner: 'bubbles',
      duration: 30000
    });
  }

  confirm() {
    this.authService.validateOtp({otp: this.otp}, this.tfa.document).subscribe((res) => {
      this.valueChange.emit('true');
      console.log(res);
    });
  }

  validateOtp() {
    this.loading.present();
    const body = {otp: this.optInput.join('')}
    this.authService.validateOtp(body, this.userId).subscribe((data: any) => {
      this.loading.dismiss();
      if (data.result) {
        window.location.href = '/main';
      }
    }, error => {
      console.warn(error);
      this.presentToast('No fue posible verificar el otp');
    });
  }

  sendSmsOtp(isRecoveryQr?: boolean) {
    this.loading.present();
    this.authService.sendOtp(this.userId, {isSms: true}).subscribe((res: any) => {
      this.presentToast('Codigo enviado al Teléfono registrado');
      this.loading.dismiss();
      if (isRecoveryQr) {
        this.recoveryQr();
      }
    });
  }

  focusNext(event: KeyboardEvent, index: number) {
    const inputValue = (event.target as HTMLInputElement).value;
    const isBackspace = event.key === 'Backspace';

    if (isBackspace && index > 0) {
      const previousIndex = index - 1;
      const previousInput = document.querySelector(`input[tabindex="${previousIndex}"]`) as HTMLInputElement;
      if (previousInput) {
        previousInput.focus();
        previousInput.select();
      }
    } else if (inputValue && inputValue.length > 0) {
      const nextIndex = index < 6 ? index + 1 : index;
      const nextInput = document.querySelector(`input[tabindex="${nextIndex}"]`) as HTMLInputElement;
      if (nextInput) {
        nextInput.focus();
        nextInput.select();
      }
    }
  }


  async presentToast(txt) {
    const toast = await this.toastController.create({
      message: txt,
      duration: 3000,
      position: 'top',
      mode: 'ios',
      color: 'dark'
    });
    toast.present();
  }

  private recoveryQr() {

  }
}
